import { useGeneral } from '@utils/general';

const {closeOnEsc, trapFocus} = useGeneral();

const useCallToAction = () => {
  let callToActionElement = document.querySelector('.call-to-action');
  let callToActionToggleButton: HTMLButtonElement = callToActionElement!.querySelector(".call-to-action__toggle-button")!;
  let callToActionShape = document.querySelector('.call-to-action__toggle-shape');
  let isOpen = false;

  const setHeightOfShape = () => {
    callToActionToggleButton.querySelector("span")!.classList.add('hidden-visibility');

    setTimeout(() => {
      const height = parseInt(String(callToActionToggleButton!.clientHeight));
      const paddingToRemove = 15;

      callToActionShape?.setAttribute('style', `height: ${height - paddingToRemove}px`);
      callToActionToggleButton.querySelector("span")!.classList.remove('hidden-visibility');
    }, 200);
  }

  const openSidebar = () => {
    callToActionElement?.classList.add('call-to-action--open');
    isOpen = true;
    hideFocusForElements(false);
    document.addEventListener(`keydown`, initFocusTrap);
    callToActionToggleButton.ariaExpanded = "true";
    setHeightOfShape();
  }

  const closeSidebar = () => {
    callToActionElement?.classList.remove('call-to-action--open');
    isOpen = false;
    hideFocusForElements(true);
    document.removeEventListener(`keydown`, initFocusTrap);
    callToActionToggleButton.ariaExpanded = "false";
    setHeightOfShape();
  }

  // Toggle the focus from the elements in the call to action sidebar, so the user can't tab through them when the sidebar is closed
  const hideFocusForElements = (hide: boolean) => {
    document.querySelectorAll('.call-to-action a, .call-to-action button:not(.call-to-action__toggle-button)').forEach((element) => {
      if (hide) {
        element.setAttribute('tabindex', '-1');
      } else {
        element.removeAttribute('tabindex');
      }
    });
  }

  // Trap the focus inside the call to action sidebar
  const initFocusTrap = (event: KeyboardEvent) => {
    trapFocus(event, document.querySelectorAll('.call-to-action a, .call-to-action button'), isOpen);
  }

  // Set the height of the shape to match the height of the button
  setHeightOfShape();

  // Toggle the call to action sidebar
  document.querySelector('.call-to-action__toggle-button')?.addEventListener('click', () => {
    if (isOpen) {
      closeSidebar();
    } else {
      openSidebar();
    }
  });

  // Close the sidebar when escape is pressed
  window.addEventListener('keyup', (event: KeyboardEvent): void => {
    if (isOpen) {
      closeOnEsc(event, () => {
        closeSidebar();
      });
    }
  });

  // Close the sidebar when clicking outside of it
  document.addEventListener('click', (event: MouseEvent) => {
    if (isOpen && !callToActionElement?.contains(event.target as Node)) {
      closeSidebar();
    }
  });

  // Initialize and hide the focus for the elements in the sidebar
  hideFocusForElements(true);
};

useCallToAction();